<template>
    <div data-qa="sequence-settings-modal" class="setting-cell-modal">
        <DsModal
            center
            show-close
            size="xs"
            :is-open="isOpen"
            :title="$t('funnel.flow.setting.title')"
            @close="closeModal"
        >
            <section class="sequence-type-container">
                <span class="sequence-type-label"> {{ $t('funnel.flow.setting.summary') }} </span>
                <div class="radio-group-stop-continue">
                    <DsRadio
                        v-model="flowType"
                        data-qa="flow-type-stop"
                        class="flow-type-stop"
                        :val="$options.FLOW_TYPE_SETTING.STOP"
                        required
                    >
                        <span>{{ $t('funnel.flow.setting.type.stop.label') }}</span>
                    </DsRadio>
                    <DsRadio
                        v-model="flowType"
                        data-qa="flow-type-continue"
                        class="flow-type-continue"
                        :val="$options.FLOW_TYPE_SETTING.CONTINUE"
                        required
                    >
                        <span>{{ $t('funnel.flow.setting.type.continue.label') }}</span>
                    </DsRadio>
                </div>

                <div class="button-group-action">
                    <DsButton
                        class="save-button"
                        data-qa="button-save-config"
                        @click="saveConfig"
                    >
                        {{ $t('funnel.flow.setting.type.save') }}
                    </DsButton>
                    <DsTextButton blue @click="closeModal">
                        {{ $t('funnel.edit.lightbox.rulegroup.button.cancel') }}
                    </DsTextButton>
                </div>
            </section>
        </DsModal>
    </div>
</template>
<script>
import { FLOW_TYPE_SETTING } from '../utils/editor.constants';

export default {
    FLOW_TYPE_SETTING,
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        cell: {
            type: Object,
            required: true,
        },
    },
    emits: ['update-cell', 'close-cell-settings-modal'],
    data() {
        return {
            flowType: this.cell.value.flowType || FLOW_TYPE_SETTING.STOP,
            flowName: this.cell?.value?.name || '',
            originalFlowType: this.cell?.value?.flowType || '',
        };
    },
    computed: {
        configurationHaveNotChanged() {
            return this.originalFlowType === this.flowType;
        },
    },
    methods: {
        saveConfig() {
            if (this.configurationHaveNotChanged) {
                this.closeModal();

                return;
            }

            const { cell, flowType } = this;

            const cellValue = { ...cell.value, flowType };

            this.$emit('update-cell', { cell: { ...cell, value: cellValue }, isReady: cell.value.ready === '1' });
            this.closeModal();
        },
        closeModal() {
            this.$emit('close-cell-settings-modal');
        },
    },
};
</script>
<style lang="scss" scoped>
.setting-cell-modal {
    --modal-padding: 0;
    --radio-padding: 0;
}
div > label.radio.flow-type-continue > div.label-container > span,
div > label.radio.flow-type-stop > div.label-container > span {
    margin-left: $spacing-100;
}

.radio.flow-type-continue {
    padding-top: var(--radio-padding);
}

.radio-group-stop-continue {
    margin-top: $spacing-100;
}

.save-button {
    margin-right: $spacing-125;
}

</style>
